<template>
<div :style="style">
	<Tree v-if="dialog.multiple"  ref="tree" :data="treeData" :load-data="loadData" show-checkbox :check-strictly="false" @on-check-change="checkChange"></Tree>
	<Tree v-else ref="tree" :data="treeData" :load-data="loadData" @on-select-change="selectChange" ></Tree>
</div>
</template>

<script>
/**
 * 
 */
import Vue from 'vue';
export default {
	props : {
		dialog :{},
		initData : {
			default : []
		},
		param : {},
		expand : {},
		selectChange : {
			default : function(){
			  return function (nodes,node) {

        		}
			}
		}
	},
  	data :function () {
	    return {
	    	treeData : [],
	    	treeMap : {},
	    	style : {
	    		overflow : "auto"
	    	},
	    	allData : []
	    }
	},
 	mounted : function(){
 		let h = this.dialog.height;
 		if(this.dialog.height <= 100){
 			h =  window.innerHeight * ("0." + this.dialog.height);
 		}
 		this.style.height = (h - 150)+"px";
 		
 		this.dialog.conditionFields.forEach(field => {
 			var searchName = field.columnName + "$";
 			if (field.dbType === "varchar") {
 				searchName += "V";
 			}
 			if (field.dbType === "number") {
 				searchName += "N";
 			}
 			if (field.dbType === "date") {
 				searchName += "D";
 			}
 			searchName += field.condition;
 			field.searchName = searchName;
 			if(this.param&&this.param[field.columnName]){
 				this.param[searchName] = this.param[field.columnName];
 			}
 		});
 		
 		let url = "/form/formCustDialog/treeData_" + this.dialog.key;
 		let post = Vue.abHttpUtil.postForm(url, this.param||{});
 		post.then(result => {
 			this.treeData = this.buildTree(result);
  		}, function (status) {
	  		if (status == !0) {
		  		Vue.prototype.$Message.error('加载失败！' + status);
		  	}
		});
 	},
	methods: {
		//构建tree
	  	buildTree : function(data, parentId,parent){
			if(!parentId){//找到根节点
				data.forEach(item => {
					let root = true;
					data.forEach(ite => {
						if(item[this.dialog.treeConfig.pid] == ite[this.dialog.treeConfig.id]){
							root = false;
						}
					});
					if(root){
						parentId = item[this.dialog.treeConfig.pid];
					}
				});
			}
  			let tree = [];
  			let temp;
  			for (let i = 0; i < data.length; i++) {
  				if (data[i][this.dialog.treeConfig.pid] == parentId) {
  					let obj = data[i];
  					temp = this.buildTree(data, data[i][this.dialog.treeConfig.id],data[i]);
  					if (temp.length > 0) {
  						obj.children = temp;
  					}
  					obj.title = obj[this.dialog.treeConfig.showColumn];
  					
  					if(this.dialog.treeConfig.sync){
  						if(obj.isParent){
  							obj.loading = false;
  	  						obj.children = [];
  						}
  					}else{
  						obj.expand = true;
  	  					if(this.expand != null){
  	  						obj.expand = this.expand;
  	  					}
  					}
  					
  					this.initData.forEach(item => {
  						if(this.dialogEqual(item,obj)){
  							if(this.dialog.multiple){
  								obj.checked = true;
  							}else{
  								obj.selected = true;
  							}
  						}
  					});
  					
  					if(parent){
  						obj.parent = parent;
  					}
  					
  					tree.push(obj);
  				}
  			}
  			return tree;
	  	},
	  	// 仅以a中存在的字段跟b作相等比较（可以理解为a字段少，b字段多）
	  	dialogEqual : function(a,b){
			for(let key in a){
				let isExist = false;
				this.dialog.returnFields.forEach(field => {
					if(key==field.columnName){
						isExist = true;
					}
				});
				if(!isExist){
					continue;
				}
				
				if(a[key] != b[key]){
					return false;
				}
			}
			return true;
	  	},
	  	getData : function(){
	  		if(this.dialog.multiple){
	  			return this.$refs.tree.getCheckedNodes();
	  		}
	  		return this.$refs.tree.getSelectedNodes();
	  	},
	  	loadData : function(item, callback){
	 		let url = "/form/formCustDialog/treeData_" + this.dialog.key;
	 		let p = this.param||{};
	 		p[this.dialog.treeConfig.pid] = item[this.dialog.treeConfig.pid];
	 		p[this.dialog.treeConfig.id] = item[this.dialog.treeConfig.id];
	 		let post = Vue.abHttpUtil.postForm(url, p);
	 		post.then(result => {
	 			let data = this.buildTree(result,item[this.dialog.treeConfig.id],item);
	 			callback(data);
	  		}, function (status) {
		  		if (status == !0) {
			  		Vue.prototype.$Message.error('加载失败！' + status);
			  	}
			});
	  	},
	  	checkChange : function(nodes,node){
	  		if(!this.dialog.treeConfig.chkboxType){
	  			return;
	  		}
	  		let chkboxType = JSON.parse(this.dialog.treeConfig.chkboxType);
	  		if(chkboxType["Y"]&&node.checked){//处理勾选事件
	  			if(chkboxType["Y"].indexOf("s")!=-1){
	  				this.checkChildren(node,node.checked);
	  			}
	  			if(chkboxType["Y"].indexOf("p")!=-1){
	  				this.checkParent(node,node.checked);
	  			}
	  		}
	  		if(chkboxType["N"]&&!node.checked){//处理取消勾选事件
	  			if(chkboxType["N"].indexOf("s")!=-1){
	  				this.checkChildren(node,node.checked);
	  			}
	  			if(chkboxType["N"].indexOf("p")!=-1){
	  				this.checkParent(node,node.checked);
	  			}
	  		}
        },
        //勾选子列表
       	checkChildren : function(node,checked){
       		if(!node.children){
       			return;
       		}
       		node.children.forEach(c => {
     			this.$set(c,"checked",checked);
	   			this.checkChildren(c,checked);
   		 	});
        },
      	//勾选父列表
       	checkParent : function(node,checked){
       		if(!node.parent){
       			return;
       		}
       		if(!checked){//取消父要同级节点都取消才去触发
       			let b = true;
       			node.parent.children.forEach(c => {
       				if(c.checked){
       					b = false;
       				}
       			});
       			if(!b){
       				return;
       			}
       		}
       		this.$set(node.parent,"checked",checked);
     		this.checkParent(node.parent,checked);
        }
  	},
 	watch : {
 	}
}
</script>
